import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

// ---- Ensure the TXT exporter from /public is available globally ----
// If ewp_export.js is placed in frontend/public, it is served at /ewp_export.js
// We inject it once here so window.EWP_EXPORT.downloadTxt exists app‑wide.
(function ensureEwpExport() {
  if (typeof window === "undefined") return;
  if (window.EWP_EXPORT?.downloadTxt) return; // already loaded

  const existing = document.querySelector('script[data-ewp-export="1"]');
  if (existing) return; // someone else appended it

  const s = document.createElement("script");
  s.src = "/ewp_export.js"; // public root
  s.async = true;
  s.defer = true;
  s.dataset.ewpExport = "1";
  document.head.appendChild(s);
})();
// -------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
